import '../../style/index.css';
import '../../grid/style/index.css';


//////////////////
// WEBPACK FOOTER
// ./node_modules/ant-design-vue/es/col/style/css.js
// module id = G13B
// module chunks = 0